import React from 'react';

interface CelestialLayoutProps {
  children: React.ReactNode;
  /** Login gibi tam ekran glow sayfalarında ekstra orb göster */
  orbs?: boolean;
}

export default function CelestialLayout({ children, orbs = false }: CelestialLayoutProps) {
  return (
    <div className="celestial-page">
      <div className="celestial-ambient" aria-hidden />
      <div className="celestial-stars" aria-hidden />
      {orbs && (
        <>
          <div className="celestial-glow-orb celestial-glow-orb--tl" aria-hidden />
          <div className="celestial-glow-orb celestial-glow-orb--br" aria-hidden />
        </>
      )}
      {children}
    </div>
  );
}
